import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-errores-reporte',
  templateUrl: './errores-reporte.component.html',
  styleUrls: ['./errores-reporte.component.scss']
})
export class ErroresReporteComponent {
  @Input() errores: any[] = [];

  public panelOpenState: boolean = true;

  openPanel(): void {
    this.panelOpenState = true;
  }
}
